/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, Inject, EventEmitter } from "@angular/core";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";

@Component({
  selector: "addProducts",
  templateUrl: "./addProducts.component.html",
  styleUrls: ["./addProducts.component.scss"],
})
export class addProductsComponent {
  inventoryItems: any;
  products;
  onAdd = new EventEmitter();
  isPriceDisplay;
  isWishList;
  isCart;
  addProduct = false;
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<addProductsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {
    this.inventoryItems = data.inventoryItems;
    this.isPriceDisplay = data.isPriceDisplay;
    this.isWishList = data.isWishList;
    this.isCart = data.isCart;

    this.products = data.inventoryItems.map((item) => {
      return {
        inventory: item._id,
        numberOfUnits: 0,
        itemMaster: item.itemMaster,
      };
    });

    this.inventoryItems.forEach((item) => {
      if (data.aggregated) {
        data.aggregated.forEach((cartItem) => {
          if (item._id === cartItem.inventory._id) {
            item.sizeValue = cartItem.numberOfUnits
              ? cartItem.numberOfUnits
              : 1;
          }
        });
      }
    });

    this.products.forEach((item) => {
      if (data.aggregated) {
        data.aggregated.forEach((cartItem) => {
          if (
            item.inventory === cartItem.inventory._id &&
            cartItem.numberOfUnits
          ) {
            item.numberOfUnits = cartItem.numberOfUnits;
          }
        });
      }
    });
  }

  updateQuantity = (data) => {
    const { id, value } = data;
    const currentProduct = this.products.find(
      (product) => product.inventory === id
    );
    currentProduct.numberOfUnits = value;
    this.addProduct = this.products.some(
      (element) => element.numberOfUnits > 0
    );
  };

  OnAddClicked = () => {
    this.onAdd.emit(this.products);
    // this._bottomSheetRef.dismiss(this.products);
  };
}
